import { render, staticRenderFns } from "./mBanner.vue?vue&type=template&id=af5b45e0&scoped=true"
import script from "./mBanner.vue?vue&type=script&lang=js"
export * from "./mBanner.vue?vue&type=script&lang=js"
import style0 from "./mBanner.vue?vue&type=style&index=0&id=af5b45e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5b45e0",
  null
  
)

export default component.exports